import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CorrectiveActionTemplate {
  id: string;
  name: string;
  title?: string;
  description: string;
  category?: string;
  priority?: 'low' | 'medium' | 'high';
  estimated_duration?: number;
  steps?: string[];
  trigger_reason?: string;
  created_at?: string;
}

export interface TemplateRequest {
  title: string;
  name: string;
  description: string;
  category: string;
  priority: 'low' | 'medium' | 'high';
  estimated_duration: number;
  steps: string[];
  triggerReason?: string;
}

export interface TemplateResponse {
  id: string;
  template_id?: string;
  name: string;
  title: string;
  description: string;
  category: string;
  priority: 'low' | 'medium' | 'high';
  estimated_duration: number;
  steps: string[];
  triggerReason?: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class CorrectiveActionTemplateService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/corrective-action-templates`;

  getTemplates(): Observable<CorrectiveActionTemplate[]> {
    return this.http.get<CorrectiveActionTemplate[]>(this.baseUrl);
  }

  getTemplatesByCategory(category: string): Observable<CorrectiveActionTemplate[]> {
    return this.http.get<CorrectiveActionTemplate[]>(`${this.baseUrl}/category/${category}`);
  }

  createTemplate(template: TemplateRequest): Observable<TemplateResponse> {
    return this.http.post<TemplateResponse>(this.baseUrl, template);
  }

  updateTemplate(id: string, template: Partial<TemplateRequest>): Observable<TemplateResponse> {
    return this.http.put<TemplateResponse>(`${this.baseUrl}/${id}`, template);
  }

  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
